import { db } from "../firebase-config"
import { collection, getDocs, query, where, doc, updateDoc } from "firebase/firestore"

export const baseUrl = [
  {
    url: 'form/formtesteofc5',
    label: 'Form test OFC 5'
  },
  {
    url: 'form/formtesteofc2',
    label: 'Form test OFC 2'
  },
  {
    url: 'form/formtesteofc3',
    label: 'Form test OFC 3'
  },
  {
    url: 'todos',
    label: 'Clientes Cadastrados'
  },
  {
    url: 'form/formtesteofc',
    label: 'Form Teste OFC'
  },
  {
    url: 'renegociacao/pf',
    label: 'Renegociação somente PF'
  },
  {
    url: 'renegociacao/pj',
    label: 'Renegociação somente PJ'
  },
  {
    url: 'renegociacao/loginUTM',
    label: 'Acordo com Limite'
  },
  {
    url: 'credito/home',
    label: 'Crédito Preventivo'
  },
  {
    url: 'emprestimo/login',
    label: 'Crédito / JUC / Geral'
  },
  {
    url: 'juc-cp-puro',
    label: 'Crédito / JUC / CP Puro'
  },
  {
    url: 'juc-csg-puro',
    label: 'Crédito / JUC / CSG Puro'
  },
  {
    url: 'juc-credito-fgts',
    label: 'Crédito / JUC / FGTS'
  },
  {
    url: 'upselling/credito',
    label: 'Comprovante Crédito'
  },
  {
    url: 'banco/capitalizacao',
    label: 'DinDin Capitalização'
  },
  {
    url: 'investimentos-e-previdencia/cdb-di',
    label: 'CDB DI'
  },
  {
    url: 'banco/seguro-transacoes',
    label: 'Seguro Transações'
  },
  {
    url: 'cartao-credito-santander',
    label: 'Cartões'
  },
  {
    url: 'consorcios/simulacao/comecar/revisao-dados',
    label: 'Consórcio 1(Inicio jornada)'
  },
  {
    url: 'consorcios/planos/lista/sugestoes',
    label: 'Consórcio 2(Meio jornada)'
  },
  {
    url: 'consorcios/pagamento/detalhes',
    label: 'Consórcio 3(Fim jornada)'
  },
  {
    url: 'parcelamento-fatura/simulacao',
    label: 'Parcelamento de fatura'
  },
  {
    url: 'conta-pj',
    label: 'Conta PJ'
  }
];

export const getInfoTokensWithTotalGreaterThanZero = async () => {
  const webpushTokens = collection(db, 'webpush-tokens-count');
  const q = query(webpushTokens, where('total', '>', 0))

  const querySnapshot = await getDocs(q);
  const inforTokens = [];

  querySnapshot.forEach((doc) => {
    let retornoTokens = doc.data();

    if (retornoTokens.url != null) {
      inforTokens.push({ id: doc.id, token: retornoTokens });
    }
  });

  return inforTokens;
};

export const addOrUpdatePrazo = async (editTokenDaysValue, inputValueElement, onSuccess, onError) => {
  const webpushTokens = collection(db, 'webpush-tokens-count');
  let subCollection = doc(webpushTokens, `${editTokenDaysValue}`);

  try {
    await updateDoc(subCollection, {
      prazo: Number(inputValueElement),
    });
    onSuccess()
  } catch (error) {
    onError()
    throw error;
  }
};